(function () {
  'use strict';

  angular
    .module('traineeWebApp.dashboard')
    .directive('dotdotdot', dotdotdot);

  dotdotdot.$inject = [];

  function dotdotdot () {
    return {
      restrict: 'A',
      scope: {
        value: '=dotdotdot'
      },
      link: function (scope, element) {
        scope.$watch('value', function () {
          element.dotdotdot({
            ellipsis : '... ',
            height: 50, /* 3 x 16 or 3rem */
            watch: 'window',
            after: 'a.read-more'
          });
        });
      }
    }
  }
}());
